export default __webpack_public_path__ + "1c7c76dabc7e3af4cb43d4a25d988b28.png";